<template>
	<van-popup v-model="visible" position="bottom" round class="audit-picker">
		<van-picker
			:title="title"
			show-toolbar
			:columns="columns"
			@confirm="onConfirm"
			@cancel="visible = false"
		/>
	</van-popup>
</template>

<script>
// 单列选择弹层（对应小程序 base-select）
export default {
	name: 'AuditPicker',
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: '',
		},
		columns: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		visible: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit('input', val)
			},
		},
	},
	methods: {
		onConfirm(value) {
			this.visible = false
			this.$emit('confirm', value)
		},
	},
}
</script>
